// extracted by mini-css-extract-plugin
export default {"pinpop":"PinPop_pinpop__a3lb3"};